"use client";
import { Box } from "@mui/material";
import React from "react";

export const GetAppButton = () => {
  const scrollToSection = (name: any) => {
    const element = document.getElementById(name);
    if (!element) return;
    const navbarElement = document.querySelector(".navbar-scroller");
    const navbarHeight =
      navbarElement instanceof HTMLElement ? navbarElement.offsetHeight || 0 : 0;
    window.scrollTo({
      top: element.offsetTop - navbarHeight,
      behavior: "smooth",
    });
  };

  return (
    <Box
      component="button"
      type="button"
      aria-label="Scroll to Get the SalonTym app section"
      sx={{
        position: "fixed",
        bottom: "calc(24px + env(safe-area-inset-bottom, 0px))",
        right: 20,
        background: "none",
        width: "auto",
        height: "auto",
        zIndex: 1001,
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        display: { xs: "none", sm: "block" },
        border: "none",
        padding: 0,
        font: "inherit",
      }}
      onClick={() => scrollToSection("get-app-scroll")}
    >
      <Box
        sx={{
          background: "linear-gradient(135deg, #123524 0%, #1f7a4d 100%)",
          color: "white",
          borderRadius: "999px",
          padding: "10px 18px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "0.95rem",
          fontWeight: 700,
          letterSpacing: "-0.02em",
          boxShadow: "0 12px 32px rgba(18, 53, 36, 0.28)",
          border: "1px solid rgba(255,255,255,0.12)",
          transition: "transform 0.2s ease, box-shadow 0.2s ease",
          "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: "0 16px 40px rgba(18, 53, 36, 0.34)",
          },
        }}
      >
        Get App
      </Box>
    </Box>
  );
};
